<template>
    <form-wrapper>
        <template #footer>
            <common-buttons>
                <common-button
                    :label="$t('modals.delete_patient.buttons.cancel')"
                    :isSubmittable="false"
                    type="secondary"
                    size="large"
                    @click="emitEvent({ name: 'cancel' })"
                ></common-button>
                <common-button
                    :label="$t('modals.delete_patient.buttons.save')"
                    size="large"
                    type="primary"
                    @click="removePatient"
                ></common-button>
            </common-buttons>
        </template>
    </form-wrapper>
</template>
<script>
    import FormMixin from 'mixins/FormMixin'
    import HandleRequestMixin from 'mixins/HandleRequestMixin'
    import PatientAPI from 'api/PatientAPI'

    export default {
        mixins: [FormMixin, HandleRequestMixin],

        methods: {
            removePatient() {
                this.isLoading = true
                const patientId = this.$route.params.id
                this.handleRequest(PatientAPI.removePatient(patientId, this.$auth.getUser().id))
                    .then(() => {
                        this.$router.push('/patients/list/patients')
                    })
                    .catch(() => {})
            },
        },
    }
</script>
